import { render, staticRenderFns } from "./ErrorMessageText.vue?vue&type=template&id=3428a89a&scoped=true&"
import script from "./ErrorMessageText.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageText.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageText.vue?vue&type=style&index=0&id=3428a89a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3428a89a",
  null
  
)

export default component.exports